/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * ArchiveStudyModal — Confirmation modal for archiving an EOS study.
 * Migrated from: lego/page/eos/transfer-media/ArchiveStudyModal.jsx
 */

import { useState, useEffect } from 'react'
import { useServiceContext } from '../../../root'
import Modal from '../../../components/Modal'
import type { ArchiveStudyModalProps } from './types'

const ArchiveStudyModal: React.FC<ArchiveStudyModalProps> = ({ ftpConfig }) => {
  const [isOpen, setIsOpen] = useState(true)
  const context = useServiceContext()
  const [activeWfCount, setActiveWfCount] = useState(0)
  const { translate } = context.service.filter

  useEffect(() => {
    if (ftpConfig.studyFolderId) {
      context.api.eos.getStudyWorkflowsCount(ftpConfig.studyFolderId, 'ACTIVE').then(
        (_data) => {
          setActiveWfCount(_data as number)
        },
        (error: { data?: { message?: string } }) => {
          context.service.toast.error(error?.data?.message ?? 'ERROR')
        }
      )
    }
  }, [])

  const doClose = () => {
    setIsOpen(false)
  }

  const archiveStudy = () => {
    const reqData = {
      ftpContextId: ftpConfig?.id ?? undefined,
      studyFolderId: ftpConfig?.studyFolderId
    }
    context.api.eos.archiveEosStudy(reqData).then(
      () => {
        context.service.toast.success('ARCHIVE_SUCCESS_MESSAGE')
        context.$rootScope.$emit('archivedStudy')
        doClose()
      },
      (error: { data?: { message?: string } }) => {
        context.service.toast.error(error?.data?.message ?? 'ERROR')
        doClose()
      }
    )
  }

  return (
    <Modal
      show={isOpen}
      handleClose={doClose}
      title={translate('ARCHIVE_STUDY')}
      isLevelTwoModal
      className="level-one-modal"
    >
      <Modal.Body>
        <div className="fs12">
          {translate('ARCHIVE_STUDY_CONFIRMATION')} <b>{ftpConfig?.name}</b>
          {!!activeWfCount && (
            <div className="active-wf-message-container">
              <div className="warning-icon"></div>
              <div
                className="active-wf-count"
                dangerouslySetInnerHTML={{
                  __html: translate('ACTIVE_WF_COUNT_MESSAGE', { count: activeWfCount })
                }}
              ></div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Button variant="link" onClick={doClose}>
          {translate('NO')}
        </Modal.Footer.Button>
        <Modal.Footer.Button variant="primary" onClick={archiveStudy}>
          {translate('YES')}
        </Modal.Footer.Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ArchiveStudyModal
